"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import {
  FaArrowAltCircleUp,
  FaPhoneAlt,
  FaWhatsapp,
} from "react-icons/fa";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show scroll-to-top button after scrolling
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // Scroll back to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="bg-white text-black">
      <div className="bg-white mt-16">

        {/* ================================
            CONTACT / ADDRESS SECTION
        ================================= */}

        <div className="max-w-7xl mx-auto w-[90%]">
          <div className="bg-white py-6 flex flex-col items-center md:flex-row lg:justify-between mb-10 space-y-6 md:space-y-0 md:gap-10">

            {/* Location */}
            <div className="flex items-center gap-8 md:gap-5 text-gray-700">
              <Image
                src="/images/icon2.png"
                alt="Montransfert localisation Epalinges"
                width={35}
                height={35}
              />

              <div>
                <p className="text-gray-700 text-xl font-medium">
                  C/o Khadim, Rte de la Croix-Blanche 44,
                </p>

                <p className="text-xl font-medium">
                  1066 Epalinges, Suisse
                </p>
              </div>
            </div>

            {/* Phone & Email */}
            <div className="flex items-center gap-5">
              <div className="w-[40px] h-[40px]">
                <Image
                  src="/images/icon1.png"
                  alt="Contact Montransfert"
                  width={45}
                  height={45}
                />
              </div>

              <div className="flex flex-col">
                <p className="text-gray-700 text-xl font-medium">
                  Tel: +41 79 576 39 79
                </p>

                <p className="text-gray-700 text-xl font-medium">
                  Email: montransfert4@gmail.com
                </p>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="flex items-center gap-8 md:gap-5 text-gray-700">
              <Image
                src="/images/icon3.png"
                alt="Horaires Montransfert"
                width={40}
                height={40}
              />

              <p className="text-xl font-medium">
                Tous les jours, 7/7 - 24/24!
              </p>
            </div>

          </div>
        </div>


        {/* ================================
            SEO / SERVICES SECTION
        ================================= */}

        <section
          aria-labelledby="services-title"
          className="border-t border-gray-200 bg-[#faf9f7] py-12"
        >
          <div className="max-w-7xl mx-auto w-[90%]">

            <div className="max-w-4xl mx-auto text-center">

              <h2
                id="services-title"
                className="text-2xl md:text-3xl font-semibold text-black mb-4"
              >
                Nos services de transport et de location
              </h2>

              <p className="text-gray-600 text-sm md:text-base leading-7">
                Basé à <strong>Epalinges</strong>, près de{" "}
                <strong>Lausanne</strong>, Montransfert Sàrl propose des
                solutions de <strong>transport de personnes</strong>, de{" "}
                <strong>VTC</strong> et de{" "}
                <strong>location de véhicules</strong> dans le{" "}
                <strong>Canton de Vaud</strong> et en{" "}
                <strong>Suisse</strong>.
              </p>

              <p className="text-gray-600 text-sm md:text-base leading-7 mt-3">
                Nous proposons également des{" "}
                <strong>véhicules utilitaires</strong> pour vos besoins
                professionnels et privés, ainsi que des solutions de{" "}
                <strong>transport maritime</strong> et de{" "}
                <strong>groupage Suisse–Sénégal</strong>.
              </p>

            </div>


            {/* SEO Service Tags */}
            <div className="flex flex-wrap justify-center gap-3 mt-8">

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Epalinges
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Lausanne
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Canton de Vaud
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Suisse
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Transport de personnes
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                VTC
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Location de véhicules
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Véhicules utilitaires
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Transport maritime
              </span>

              <span className="px-4 py-2 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
                Groupage Suisse–Sénégal
              </span>

            </div>

          </div>
        </section>


        {/* ================================
            BLACK FOOTER
        ================================= */}

        <div className="bg-black">

          <footer className="bg-black py-6 px-6 text-white">

            <div className="max-w-7xl w-[90%] mx-auto flex flex-col gap-4 md:gap-0 md:flex-row justify-between items-center">

              {/* Company */}
              <div className="text-center md:text-left">
                <p className="text-[18px] lg:text-xl font-bold">
                  Montransfert Sàrl
                </p>

                <p className="text-sm">
                  Location de voiture simple, rapide et abordable.
                </p>
              </div>


              {/* Contact */}
              <div className="text-center md:text-left">
                <p className="text-sm lg:text-xl font-bold">
                  Contactez-nous!
                </p>

                <p className="text-sm text-[#deba91]">
                  Tel: +41 79 576 39 79
                </p>
              </div>


              {/* Copyright */}
              <p className="text-sm text-center">
                © 2026 Montransfert Sàrl, All Rights Reserved
              </p>

            </div>

          </footer>

        </div>


        {/* ================================
            WHATSAPP / PHONE BUTTONS
        ================================= */}

        <div className="fixed bottom-10 left-4 flex flex-col space-y-4">

          {/* WhatsApp */}
          <a
            href="https://wa.me/41795763979"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contacter Montransfert sur WhatsApp"
            className="w-10 h-10 bg-green-500 text-white flex items-center justify-center rounded-full shadow-lg hover:bg-green-600 transition"
          >
            <FaWhatsapp className="text-2xl" />
          </a>


          {/* Phone */}
          <a
            href="tel:+41795763979"
            aria-label="Appeler Montransfert"
            className="w-10 h-10 bg-green-700 text-white flex items-center justify-center rounded-full shadow-lg hover:bg-green-800 transition"
          >
            <FaPhoneAlt className="text-xl" />
          </a>

        </div>


        {/* ================================
            SCROLL TO TOP
        ================================= */}

        {isVisible && (
          <button
            onClick={scrollToTop}
            aria-label="Retour en haut de la page"
            className="fixed bottom-10 right-6 flex items-center gap-1 text-[#b59c78] text-[14px] font-medium hover:scale-110 transition-transform duration-300"
          >
            <span className="tracking-widest">
              TOP
            </span>

            <FaArrowAltCircleUp />
          </button>
        )}

      </div>
    </div>
  );
};

export default Footer;